import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BMClickFileUploaderComponent } from './bm-click-file-upload/bm-click-file-upload.component';
import { BMFileUploaderComponent } from './bm-file-uploader/bm-file.uploader.component';
import { FileUploadDraggableDirective } from './file-upload-draggable/file-upload-draggable.directive';
import { FileUploadDirective } from './file-upload/file-upload.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    BMClickFileUploaderComponent,
    BMFileUploaderComponent,
    FileUploadDirective,
    FileUploadDraggableDirective,
  ],
  exports: [
    BMClickFileUploaderComponent,
    BMFileUploaderComponent,
    FileUploadDirective,
    FileUploadDraggableDirective,
  ],
})
export class UploadersModule {}
